/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ListItem } from '@trdk/style/List';
import {
  withStyles,
  IconButton, List, ListItemSecondaryAction,
  RootRef, Typography, Button, Hidden, Divider,
  Grid, Tabs, Tab, ListItemIcon, ListItemText, LinearProgress,
} from '@material-ui/core';
import MuiListItem from '@material-ui/core/ListItem';
import EditIcon from '@material-ui/icons/Edit';
import DragIcon from '@material-ui/icons/DragIndicator';
import NotificationBar from '@trdk/style/NotificationBar';
import Warning from '@material-ui/icons/Warning';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import { fetchCommittee, postModifyMembersInCommittee, postActivateCommittee } from '../../../services/admin/committee-service';
import { fetchRole } from '../../../services/politician/profile-service';
import PoliticianDialog from '../../../components/politician-dialog';
import EditUserDialog from '../../../components/edit-user-committee';
import Dialog from '../../../components/dialog';
import ExportDialog from './export-dialog';
import * as userConstants from '../users/functions/constants';
import ElementsDialog from './elementsid-dialog';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  for (let i = 0; i < result.length; i += 1) {
    if (result[i].index !== i) {
      result[i].changed = true;
      result[i].index = i;
    }
  }

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: 'rgb(235,235,235)',
  }),
});

const compare = (oldValues, newValues) => {
  const list = newValues.map((val, index) => {
    if (index >= oldValues.length) return true;

    if (val.id === oldValues[index].id) {
      return false;
    }
    return true;
  });
  if (list.includes(true)) {
    return true;
  }
  return false;
};

class CommitteeMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      items2: [],
      open: false,
      removeDialogOpen: [],
      unsavedChanges: false,
      deactivateDialog: false,
      alreadySet: false,
      selectedTable: 0,
      openexportDialog: false,
      openElementsDialog: false,
      isSaving: false,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    const {
      dispatch,
      me: { fetched: adminFetched, fetching: adminFetching },
    } = this.props;
    dispatch(fetchClear('ADD_MEMBERS_COMMITTEE'));
    dispatch(this.loadCommittee());
    if (!adminFetched && !adminFetching) {
      dispatch(doFetch(
        'ME',
        fetchRole()
          .then((res) => {
            if (!res.ok) {
              if (res.status === 403) {
                window.location = `${window.location.origin}/#/no-access`;
              }
              throw res.statusText;
            }
            return res.json();
          }),
      ));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentCommittee: { fetched, payload } } = this.props;
    const {
      alreadySet, items2, items, selectedTable,
    } = this.state;
    if (!alreadySet && fetched) {
      if (!payload.Resources.members) payload.Resources.members = [];
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        items: selectedTable === 0 ? payload.Resources.members.filter( item => !item.next) : payload.Resources.members.filter( item => item.next),
        items2: selectedTable === 0 ? payload.Resources.members.filter( item => item.next) : payload.Resources.members.filter( item => !item.next),
        alreadySet: true,
      });
    }
    if (prevState.selectedTable !== selectedTable) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ items2: items, items: items2 });
    }
  }

  onDragEnd(result) {
    const { items } = this.state;
    const {
      currentCommittee: { payload: { Resources: data } },
    } = this.props;
    const committee = (data != null) ? data : '';

    if (!result.destination) {
      return;
    }
    const items1 = reorder(
      items,
      result.source.index,
      result.destination.index,
    );
    if (committee.members /* && items.length !== committee.members.length */) {
      this.setState({ unsavedChanges: compare(committee.members, items1) });
    }
    this.setState({ items: items1 });
  }

  loadCommittee = () => (dispatch) => {
    const {
      match: { params: { id } },
      history,
    } = this.props;
    dispatch(doFetch(
      'GET_COMMITTEE',
      fetchCommittee(id)
        .then((res) => {
          if (!res.ok) {
            history.push('/admin/utvalg');
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  handleAddPolitician = (politician, role, represents, note, from, to) => {
    const { items, selectedTable } = this.state;
    politician.role = role;
    politician.represents = represents;
    politician.note = note;
    politician.from = from;
    politician.to = to;
    politician.id = politician.value;
    politician.index = items.length;
    politician.next = selectedTable;

    if (!items.map(item => !!(item.id === politician.id && !item.remove)).includes(true) ) {
      if (!items.map(item => {
        if (item.id === politician.id && item.remove === true) {
          item.remove = false;
          return true;
        }
        return false;
      }).includes(true)) {
        items.push(politician);
      }

      this.setState({ open: false, unsavedChanges: true });

      return true;
    }

    return false;
  }

  handleRemovePolitician = (guid) => {
    const { items } = this.state;

    items.forEach((item) => {
      if (item.id === guid) {
        item.remove = true;
        this.setState({ unsavedChanges: true });
        reorder(items, item.index, items.length - 1);
      }
    });
    this.setState({ items });
  }

  deactivateCommittee = (id, status) => {
    const { dispatch, history } = this.props;
    postActivateCommittee(id, status)
      .then((res) => {
        if (!res.ok) {
          throw res.statusText;
        }
        this.setState({ deactivateDialog: false });
        dispatch(fetchClear('COMMITTEES'));
        this.loadCommittee();
        history.push('/admin/utvalg');
        return res;
      });
  }

  handleSave = () => {
    this.setState({ isSaving: true });
    const { items, items2, selectedTable } = this.state;
    const { dispatch, match: { params: { id } } } = this.props;
    const list = selectedTable === 0 ? items.concat(items2) : items2.concat(items);
    const newMembers = list.map((item, i) => ({
      display: item.display || item.label || (item.givenName ? `${item.givenName} ${item.familyName}` : ''),
      index: i,
      id: item.id,
      ref: `Users/${item.value}`,
      role: item.role,
      value: item.value,
      affiliationId: item.affiliationId,
      represents: item.represents,
      note: item.note,
      next: item.next,
      from: item.from,
      to: item.to,
      remove: item.remove,
      changed: item.changed || item.index !== i,
    }));
    dispatch(doFetch('ADD_MEMBERS_COMMITTEE', postModifyMembersInCommittee(id, newMembers)
      .then((res) => {
        if (!res.ok) {
          throw res.statusText;
        }
        dispatch(fetchClear('COMMITTEES'));
        dispatch(this.loadCommittee());
        this.setState({ unsavedChanges: false, alreadySet: false, isSaving: false });
        return res;
      })));
  }

  render() {
    const {
      items, items2, open, removeDialogOpen, unsavedChanges,
      deactivateDialog, selectedTable, openexportDialog, openElementsDialog, isSaving,
    } = this.state;
    const {
      classes,
      history,
      currentCommittee: { payload: { Resources: data }, fetching, error: fetchError },
      committeeMembersList: { error: listError },
      me: { payload: me, fetched: meFetched },
      match: { params: { id } },
    } = this.props;


    const committee = (data != null) ? data : '';

    if (items) {
      items.sort((a, b) => a.index - b.index);
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={1} direction="row" justify="space-between">
          {committee.active !== 0 && meFetched && me.active === userConstants.ENABLED
          && (
            <Hidden smUp>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" className={classes.deactivateText} onClick={() => this.setState({ deactivateDialog: true })}>
                  Deaktiver utvalg
                </Typography>
              </Grid>
            </Hidden>
          )}
          <Grid item xs={12} sm={6}>
            <Typography variant="h4" color="primary">
              {`Medlemmer i ${committee.display || committee.name || 'utvalget'} ${committee.code ? `(${committee.code})` : ''}`}
            </Typography>
          </Grid>
          {committee.active !== 0 && meFetched && me.active === userConstants.ENABLED
          && (
            <Hidden xsDown>
              <Grid item xs={12} sm={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => this.setState({ openexportDialog: true })}
                >
                  Eksporter utvalg
                </Button>
              </Grid>
              <Grid item xs={12} sm={3} className={classes.buttongrid}>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.button}
                  disabled={fetchError || fetching}
                  onClick={() => this.setState({ deactivateDialog: true })}
                >
                  Deaktiver utvalg
                </Button>
              </Grid>
            </Hidden>
          )}
          <ExportDialog
            open={openexportDialog}
            id={id}
            closeDialog={() => this.setState({ openexportDialog: false })}
          />
        </Grid>
        <Prompt when={unsavedChanges} message="Du har ulagrede endringer, er du sikker på at du vil forlate siden uten at disse blir lagret?" />
        <Typography variant="body2" className={classes.mb2} key={1}>
          Dra på medlemmene for å endre rekkefølgen i utvalget.
        </Typography>
        {!fetchError ? (
          <>
            <Tabs
              key="tabs"
              value={selectedTable}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, value) => this.setState({ selectedTable: value })}
            >
              <Tab label="Nåværende" className={classes.tab} />
              <Tab label="Neste utvalg" className={classes.tab} />
            </Tabs>
            <Divider key="divider" />
            {!fetching && items != null && (items.length > 0 ? [
              <DragDropContext onDragEnd={this.onDragEnd} key={2}>
                <Droppable droppableId="droppable">
                  {provided => (
                    <RootRef rootRef={provided.innerRef}>
                      <List disablePadding>
                        {items
                          .map((item, index) => (!item.remove && (
                            <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={index}>
                              {// eslint-disable-next-line no-shadow
                                (provided, snapshot) => (
                                  <MuiListItem
                                    ContainerComponent="li"
                                    ContainerProps={{ ref: provided.innerRef }}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={provided.draggableProps && getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style,
                                    )}
                                    divider
                                  >
                                    <ListItemIcon>
                                      <DragIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={`${item.label || `${item.givenName} ${item.familyName}` || item.label} ${item.represents ? ` (${item.represents})` : ''}`}
                                      secondary={`${item.role || ''}, ${
                                        item.from && new Date(item.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' })} - ${
                                        item.to ? new Date(item.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }) : ''}`}
                                      className={item.role === 'Varamedlem' ? classes.pl : ''}
                                    />
                                    <IconButton onClick={() => this.setState({
                                      removeDialogOpen: { ...removeDialogOpen, [item.id.toString()]: true },
                                    })}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <EditUserDialog
                                      open={!!removeDialogOpen[item.id.toString()]}
                                      user={item}
                                      handleClose={() => this.setState({
                                        removeDialogOpen: { ...removeDialogOpen, [item.id.toString()]: false },
                                      })}
                                      removeMember={() => {
                                        this.handleRemovePolitician(item.id);
                                        this.setState({
                                          removeDialogOpen: { ...removeDialogOpen, [item.id.toString()]: false },
                                        });
                                      }}
                                      handleSave={(role, represents, note, from, to) => {
                                        this.setState({
                                          removeDialogOpen: { ...removeDialogOpen, [item.id.toString()]: false },
                                          unsavedChanges: true,
                                        });
                                        if (items[index].role !== role || items[index].represents !== represents) items[index].from = new Date();
                                        else items[index].from = from;
                                        items[index].role = role;
                                        items[index].represents = represents;
                                        items[index].note = note;
                                        items[index].to = to;
                                        items[index].changed = true;
                                      }}
                                    />
                                    <ListItemSecondaryAction />
                                  </MuiListItem>
                                )}
                            </Draggable>
                          )))}
                        {provided.placeholder}
                        <MuiListItem divider>
                          <Button color="primary" variant="outlined" onClick={() => this.setState({ open: true })}>
                            + Legg til medlem i utvalget
                          </Button>
                        </MuiListItem>
                      </List>
                    </RootRef>
                  )}
                </Droppable>
              </DragDropContext>,
            ] : (
              <List key={2} disablePadding component="nav">
                <MuiListItem divider className={classes.listitem}>
                  <ListItemText
                    primary="Det finnes ingen medlemmer"
                  />
                </MuiListItem>
                <MuiListItem divider>
                  <Button color="primary" variant="outlined" onClick={() => this.setState({ open: true })}>
                    + Legg til medlem i utvalget
                  </Button>
                </MuiListItem>
              </List>
            ))}
            {fetching && (
              <List disablePadding key={2} component="nav">
                {Object.keys(Array(5).fill(0))
                  .map((val) => (
                    <ListItem
                      key={`skel-${val}`}
                      primary={<Skeleton />}
                      secondary={<Skeleton />}
                    />
                  ))
                }
              </List>
            )}
          </>
        ) : (
          <NotificationBar message="Feil ved henting av medlemmene i utvalget" variant="error" />
        )}

        <PoliticianDialog
          currentUsers={items}
          handleClose={() => this.setState({ open: false })}
          open={open}
          committee={committee.display || committee.name || 'utvalget'}
          handleSave={(politician, role, represents, note, fromDate, toDate) => {
            this.handleAddPolitician(politician, role, represents, note, fromDate, toDate);
          }}
          otherUsers={items2}
          current={selectedTable === 0}
        />
        <Dialog
          open={deactivateDialog}
          title="Deaktiver utvalget"
          text={`Ønsker du å deaktivere ${committee.display || committee.name || 'utvalget'}?`}
          handleClose={() => this.setState({ deactivateDialog: false })}
          agreeButton="Deaktiver"
          handleAccept={() => this.deactivateCommittee(committee.id, false)}
        />
        {committee && (
          <ElementsDialog
            open={openElementsDialog}
            committee={committee}
            closeDialog={() => this.setState({ openElementsDialog: false })}
          />
        )}
        <div className={classes.floatbox}>
          {isSaving && !listError && <LinearProgress />}
          {unsavedChanges && (
            <div className={classes.alert}>
              <Warning style={{ marginRight: '1rem' }} />
              <Typography color="inherit" variant="body1">Du har ulagrede endringer...</Typography>
            </div>
          )}
          <Button color="primary" variant="outlined" className={classes.backBtn} onClick={() => { history.push('/admin/utvalg'); }}>
            Tilbake
          </Button>
          <Button color="primary" variant="outlined" className={classes.accept} onClick={() => { this.setState({openElementsDialog: true}) }}>
            Elements
          </Button>
          <Button color="primary" variant="contained" className={classes.accept} disabled={!unsavedChanges || (isSaving && !listError) } onClick={this.handleSave}>
            Lagre
          </Button>
        </div>
        {listError && <NotificationBar message="Feil ved lagring av medlemmene i utvalget" variant="error" />}
      </div>
    );
  }
}

const styles = theme => ({
  mb: {
    marginBottom: '0.5rem',
  },
  mb2: {
    marginBottom: '1.5rem',
    marginTop: '0.5rem',
  },
  listitem: {
    borderTop: '1px solid rgba(224, 224, 224, 1)',
  },
  root: {
    maxWidth: '60rem',
    marginBottom: '6rem',
  },
  nameTitle: {
    fontSize: '1.1rem',
    fontWeight: '500',
    color: theme.palette.primary.dark,
  },
  floatbox: {
    position: 'fixed',
    bottom: '0rem',
    background: 'white',
    padding: '1rem 0',
    width: '100%',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    flexWrap: 'wrap-reverse',
  },
  addButton: {
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      zIndex: '10',
      right: 0,
    },
  },
  accept: {
    marginTop: '1rem',
    marginLeft: '1rem',
    minWidth: '7rem',
  },
  backBtn: {
    marginTop: '1rem',
  },
  mt: {
    marginTop: '1.5rem',
  },
  buttongrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    '&:hover': {
      backgroundColor: '#f00',
      color: '#fff',
    },
    marginRight: '1rem',
    maxHeight: '39px',
  },
  deactivateText: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
  pl: {
    paddingLeft: '2rem',
  },
  alert: {
    backgroundColor: 'rgb(255, 244, 229)',
    color: 'rgb(102, 60, 0)',
    padding: '1rem',
    maxWidth: '60rem',
    marginTop: '1rem',
    borderRadius: '4px',
    display: 'flex',
  },
});

CommitteeMembers.propTypes = {
  match: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentCommittee: PropTypes.object.isRequired,
  committeeMembersList: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  currentCommittee, committeeMembersList, me,
}) => ({
  currentCommittee, committeeMembersList, me,
});

export default connect(mapStateToProps)(withRouter(withStyles(styles)(CommitteeMembers)));
